export const appName = "BlanstApp";
export const apiURL = "https://stagingapi.periodpal.in/v8/staging/public/index.php/";